// Общая заставка загрузки (ApplicationPageLoader в ApplicationLayout): переход на страницы модулей WX
// (бронирование, личный кабинет) и время, пока движок грузится или ищет рейсы.
// Состояние в useState — заставку можно включить ещё на сервере, и страница придёт уже с ней (без белого экрана).
export const usePageLoader = () => {
  const state = useState("page-loader", () => ({ visible: false, message: "" }));

  function show(message = "") {
    state.value = { visible: true, message };
  }

  function hide() {
    state.value = { visible: false, message: state.value.message };
  }

  return { state, show, hide };
};

// Полноэкранная заставка самого движка WX (тёмно-синяя с gif). Её прячем стилями (pages/booking.vue, account.vue)
// и вместо неё показываем свою, пока она есть в DOM
const WX_FULLSCREEN_LOADER = '[data-test-id="simple-loader"][class*="fullScreen"]';

// Следит за модулем WX в root: заставка видна, пока модуль ещё ничего не отрисовал или пока у него
// открыта своя полноэкранная загрузка. Скрываем с небольшой задержкой — между двумя загрузками подряд не мигает
export function useWxLoaderSync(root, { message } = {}) {
  const loader = usePageLoader();
  let observer;
  let hideTimer;
  let showTimer;

  function sync() {
    const el = unref(root);
    if (!el) return;
    const busy = !el.children.length || !!el.querySelector(WX_FULLSCREEN_LOADER);
    if (busy) {
      clearTimeout(hideTimer);
      hideTimer = null;
      if (!loader.state.value.visible && !showTimer) {
        // короткие загрузки (меньше 0,25 с) заставку не включают
        showTimer = setTimeout(() => {
          showTimer = null;
          loader.show(message?.());
        }, 250);
      }
    } else {
      clearTimeout(showTimer);
      showTimer = null;
      if (loader.state.value.visible && !hideTimer) {
        hideTimer = setTimeout(() => {
          hideTimer = null;
          loader.hide();
        }, 350);
      }
    }
  }

  function start() {
    const el = unref(root);
    if (!el) return;
    observer = new MutationObserver(sync);
    observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
    sync();
  }

  onBeforeUnmount(() => {
    observer?.disconnect();
    clearTimeout(hideTimer);
    clearTimeout(showTimer);
  });

  return { start, sync };
}
